import { AppTableColumn } from '../../_models/models';

export type SortDirectionType = 'ASC' | 'DESC';

/** The clamped content element of a header or body cell, if the cell has one. */
export function getCellContentElement(cell: HTMLElement): HTMLElement | null {
  return cell?.querySelector<HTMLElement>('.app-table-cell-clamp, .app-table-th-text') ?? null;
}

/**
 * The element that carries the cell's value: the content element itself, or its sole child when the
 * value is wrapped exactly once (a tooltip span, a link). Adornments next to the value (a tag, a copy
 * icon) leave more than one child, so the content element stays the value node.
 */
export function getCellValueNode(cell: HTMLElement): HTMLElement | null {
  const content = getCellContentElement(cell);
  if (!content) {
    return null;
  }
  return content.children.length === 1 ? content.firstElementChild as HTMLElement : content;
}

export function getTruncatedCellValue(cell: HTMLElement): string | null {
  const content = getCellContentElement(cell);
  if (!content) {
    return null;
  }
  const isClipped = content.scrollHeight > content.clientHeight || content.scrollWidth > content.clientWidth;
  return isClipped ? content.innerText.trim() : null;
}

export function getSmartSortDirection(column: AppTableColumn): SortDirectionType {
  if (column.initialSortDirection) {
    return column.initialSortDirection;
  }

  const prop = column.prop?.toLowerCase() || '';
  const type = column.type?.toLowerCase() || '';

  if (prop.includes('id') || prop.includes('external')) {
    return 'DESC';
  }

  if (type === 'date' || type === 'date-and-time' ||
      prop.includes('date') || prop.includes('time') ||
      prop.includes('created') || prop.includes('updated')) {
    return 'DESC';
  }

  if (type === 'number' || type === 'number-with-commas') {
    return 'DESC';
  }

  if (prop.includes('count') || prop.includes('total') ||
      prop.includes('amount') || prop.includes('revenue') ||
      prop.includes('price') || prop.includes('cost')) {
    return 'DESC';
  }

  return 'ASC';
}
